import {Component, OnInit} from '@angular/core'

import {ContextService} from '@app/core/services/context.service'
import {Observable} from 'rxjs'

@Component({
  selector: 'multi-tz-select',
  template: `<span class="dropdown" dropdown>
    <button
      dropdownToggle
      type="button"
      class="btn-transparent text-dark"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false">
      {{ activeTimezone$ | async }}&nbsp;<i class="icon icon-clock"></i>
    </button>
    <div class="dropdown-menu dropdown-menu-right">
      <button class="dropdown-item" type="button" (click)="selectTz('Browser')">
        Browser Time
      </button>
      <button
        class="dropdown-item"
        type="button"
        (click)="selectTz('Terminal')">
        Terminal Time
      </button>
      <button class="dropdown-item" type="button" (click)="selectTz('UTC')">
        UTC
      </button>
    </div>
  </span> `,
  standalone: false,
})
export class MultiTzSelectComponent implements OnInit {
  constructor(public context: ContextService) {}

  get activeTimezone$(): Observable<string> {
    return this.context.activeTimezone$
  }

  ngOnInit() {}

  selectTz(tz: string) {
    this.context.changeActiveTimezone(tz)
  }
}
